import React from 'react';
// @ts-ignore
import styles from './MonitoringCenterListHeader.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	customColumns?: string[];
}

const columns = [
	'component.monitoringCenter.tableHead.number',
	'component.monitoringCenter.tableHead.priority',
	'component.monitoringCenter.tableHead.state',
	'component.monitoringCenter.tableHead.requestType',
	'component.monitoringCenter.tableHead.patient',
	'component.monitoringCenter.tableHead.birthNumber',
	'component.monitoringCenter.tableHead.attendingDoctor',
	'component.monitoringCenter.tableHead.assigment',
	'component.monitoringCenter.tableHead.workplace',
	'component.monitoringCenter.tableHead.diagnosis',
	'component.monitoringCenter.tableHead.noteForMedics',
	'component.monitoringCenter.tableHead.created',
	'component.monitoringCenter.tableHead.lastEdit',
];

const MonitoringCenterListHeader: React.FC<Props> = ({ customColumns }) => {
	const { t } = useTranslation();
	const cols = customColumns ?? columns;
	return (
		<thead className={styles.wrapper}>
			<tr>
				{cols.map((item, key) => (
					<React.Fragment key={key}>
						<th>{t(item)}</th>
					</React.Fragment>
				))}
				<th></th>
			</tr>
		</thead>
	);
};

export default MonitoringCenterListHeader;
